






































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';
import { IGrant, IGrantAmendment } from "@/entities";

const namespace: string = "grantAmendment";

@Component({
    components: {
        HeaderInfo
    }
})
export default class GrantAmendment extends Vue {
    @Getter("readGrant", { namespace: "grant" }) grant: IGrant;
    @Prop() grantId: number;

    amendments: any = [];
    search: string = '';
    headers: any = [];
    editIcon = 'mdi-pencil-outline';

    mounted() {
        this.headers = _app.amendmentHeaders;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any) {
        if (changedRoute && changedRoute.name === 'grantSummary') {
            // List grant amendments
            this.$services.grantAmendment.listGrantAmendments(this.grantId)
                .then((resp: any) => {
                    if (resp.Result === 'OK') {
                        this.amendments = resp.Record;
                    } else {
                        this.amendments = [];
                    }
                });
        }
    }

    formatDate(dt: any) {
        return utils.formatDate(dt);
    }

    /** edit the selected item */
    editItem(item: any) {
        this.$router.push({
            name: "amendment",
            params: { amendmentId: item.GrantAmendmentId },
            hash: '#summary'
        });
    }
}
